import styled from 'styled-components';
import { RowTable } from '../../../../func/components/Table';
import { HouseInfoProps } from '../../data';
import { useState } from 'react';
import ListContent, { ListData } from '../ListContent';

interface Props {
  houseInfo: HouseInfoProps;
}

const BuildingInfo = ({ houseInfo }: Props) => {
  const data: ListData[] = [
    {
      label: '연면적',
      value: houseInfo.totalfloorarea.toFixed(1),
      isArea: true,
      value_p: Number(houseInfo.totalfloorpyeong).toFixed(1),
      hasToggleButton: true,
    },
    {
      label: '건물층수',
      value: `${houseInfo.groundfloornum}층${
        houseInfo.basementfloornum ? `/지하${houseInfo.basementfloornum}층` : ''
      }`,
    },
    { label: '건폐율', value: `${houseInfo.buildingtolandratio}%` },
    { label: '용적률', value: `${houseInfo.floorarearatio}%` },
    { label: '주용도', value: houseInfo.mainpurposecodename },
    { label: '건물구조', value: houseInfo.structurecodename },
    {
      label: '노후년도',
      value:
        houseInfo.created_year && houseInfo.old_year
          ? `${houseInfo.created_year}년 (노후${houseInfo.old_year}년)`
          : '-',
    },
  ];

  return <ListContent data={data} />;
};

export default BuildingInfo;
